import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
export var brandActivePeteEventDataFn = function brandActivePeteEventDataFn(_context) {
  var _getBrand;
  return Promise.resolve((_getBrand = getBrand()) !== null && _getBrand !== void 0 && _getBrand.active ? "ACTIVE" : "INACTIVE");
};